import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from 'posthog-js';
import { useAuth } from '../AuthContext'; // Fixed path

const PageTracker = () => {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    if (!posthog) return;

    // Optional: re-identify in case session was lost/refreshed
    if (user && user.id) {
      posthog.identify(user.id, {
        email: user.email,
        name: user.name,
        role: user.role,
      });
    }

    // Track pageview
    posthog.capture('$pageview', {
      $current_url: window.location.href,
      pathname: location.pathname,
    });
  }, [location, user]);

  return null; // no UI
};

export default PageTracker;
